import { render } from "./activeforms.vue?vue&type=template&id=e64fb54e"
import script from "./activeforms.vue?vue&type=script&lang=js"
export * from "./activeforms.vue?vue&type=script&lang=js"

import "./activeforms.vue?vue&type=style&index=0&id=e64fb54e&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__